<button class="btn p-0" (click)="onSelect()">
  <img [src]="logo" />
  <div class="auth-label">{{ name }}</div>
</button>

<div [innerHtml]="description" class="mt-2 ps-1 pe-1 text-muted text-smaller"></div>
